import React from 'react';
import NavBarWithoutLogo from "../../components/header/navaBarWithoutLogo";
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const ErrorWhite: React.FC = () => {

    const GroupImage = "/documents/d/guest/Group-40786";
    const location = useLocation();
    const mensaje = location.state?.error || "El documento de identidad ingresado no está registrado o las credenciales son incorrectas.";
    const navigate = useNavigate();

    const handleOnClick = () => {
        navigate(-1);
    }
    return (
        <>
            <div
                data-animation="default"
                data-collapse="medium"
                data-duration="400"
                data-easing="ease"
                data-easing2="ease"
                role="banner"
                className="menu is-blanco w-nav"
            >
                <NavBarWithoutLogo />
            </div>
            <section className="info-h">
                <div className="padding-global">
                    <div className="padding-section-large">
                        <div className="container-medium">
                            <div className="info_wrp"><img src={GroupImage} loading="lazy" alt="" />
                                <div className="title-component is-center">
                                    <h1 className="heading-style-h2">{mensaje}</h1>
                                    <div className="line-title"></div>
                                </div>
                                <div>Intenta nuevamenteo llámanos al 01 219 1919</div>
                                <button onClick={handleOnClick} className="button is-large w-button">Volver a intentar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ErrorWhite;